import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { observable, Observable } from 'rxjs';
import { FormService, FormServiceResolver } from 'src/app/core/services/v2/form.service';

@Component({
  selector: 'app-form-preview',
  templateUrl: './form-preview.component.html',
  styleUrls: ['./form-preview.component.scss']
})
export class FormPreviewComponent implements OnInit {

  @Input() formId: number;
  fontSize: number =16;
  iframeLocalUrl : SafeHtml;
  formHtml : string;
  reader : FileReader;

  
  constructor( private sanitizer: DomSanitizer, private formServiceResolver: FormServiceResolver,
    @Inject(MAT_DIALOG_DATA) public data: any
    ) {
      if (data) {
        this.formId = data.formId;
      }
    };


  GetFormHtmlBlob() : Observable<Blob>
  {
    var obs = new Observable<Blob>((observer) =>
      {
        this.formServiceResolver.getFormService()
        .subscribe( 
          (fSvc) => 
          {
            fSvc.getFormPreviewHtml(this.formId).subscribe( htmlBlob => observer.next(htmlBlob) ) 
          }
          
          );
      }
      );
   
      return obs;

  }
  ngOnInit() { 
    this.GetFormHtmlBlob().subscribe
    (
      (html) =>{
        
        this.reader = new FileReader();
        this.reader.addEventListener('loadend', () => {
          this.formHtml = this.reader.result as string;
          this.setIframehtml(this.formHtml);
        // reader.result contains the contents of blob as a typed array
      });
      this.reader.readAsText(html);
    }

    )
  }

  increaseFontSize()
  {
    this.fontSize = this.fontSize +2;
    this.setIframehtml(this.formHtml);
  }

  decreaseFontSize()
  {
    this.fontSize = this.fontSize -2;
    this.setIframehtml(this.formHtml);
  }

  setIframehtml(htmlStr : string)
  {
    // var htmlStr : string = this.reader.result as string;
    const fontSizeCss = `<style>html { font-size: ${this.fontSize}px;}</style>`;
    // var newHtml = new Blob([this.reader.result], {type : 'text/html'}) 

    htmlStr = htmlStr.replace('</head>',fontSizeCss+'</head>');
    var newHtml = new Blob([htmlStr], {type : 'text/html'}) 
    const a = URL.createObjectURL(newHtml);
    this.iframeLocalUrl =  this.sanitizer.bypassSecurityTrustResourceUrl(a );
  }

}
